// Shared logout side-effects, used by both the global header button
// in `__root.tsx` and the in-page Sign Out button in `/account`.
//
// Side-effects beyond `authClient.signOut()` itself:
//   - Clear the cached Ember palette so the next anonymous render
//     doesn't inherit the previous user's bond colors until
//     /api/palettes/sample resolves.
//
// The actual navigation (e.g. `navigate({ to: '/login' })`) is left to
// the caller because the route hooks live in component scope and
// differ slightly per surface (the header navigates to /login,
// /account could too, but a future page might prefer / instead).

import { authClient } from './auth-client';
import { clearCachedEmberPalette } from './use-ember-theme';

export async function performSignOut(): Promise<void> {
  clearCachedEmberPalette();
  await authClient.signOut();
}
